// extracted by mini-css-extract-plugin
export default {"audio-container":"App_audio-container__4fvCh","hidden":"App_hidden__-lVnE"};